<script lang="ts">
	import { mathNormalize, percent_from_value_range } from 'src/helpers/utilities';
	import WeatherStationCard from './WeatherStationCard.svelte';
	import { format } from 'svelte-i18n';

	export let statuses;

	$: illuminance = statuses.find((i) => i.name === 'illuminance:0');
	$: uv = statuses.find((i) => i.name === 'UV:0');

	const BAR_MIN = 2.5;
	const BAR_MAX = 105;
	const MIN_UV = 0;
	const MAX_UV = 11;

	let status = '';
	let leftCircleX: number = BAR_MIN;
	$: if (typeof uv?.rawValue === 'number') {
		const value = mathNormalize(uv?.rawValue, MIN_UV, MAX_UV);
		const p = percent_from_value_range(value, [MIN_UV, MAX_UV]);
		leftCircleX = BAR_MIN + (BAR_MAX - BAR_MIN) * (p / 100);
		status =
			uvRanges.find((range) => {
				return range.from <= value && range.to >= value;
			})?.value || uvRanges[0].value;
	}

	// 0 None, 1–2 Low, 3–5 Moderate, 6–7 High, 8–10 Very High, 11+ Extreme
	const uvRanges = [
		{
			from: 0,
			to: 0,
			value: $format('option_none', { default: 'None' }),
		},
		{
			from: 1,
			to: 2,
			value: $format('option_low', { default: 'Low' }),
		},
		{
			from: 3,
			to: 5,
			value: $format('option_moderate', { default: 'Moderate' }),
		},
		{
			from: 6,
			to: 7,
			value: $format('option_high', { default: 'High' }),
		},
		{
			from: 8,
			to: 10,
			value: $format('option_very_high', { default: 'Very High' }),
		},
		{
			from: 11,
			to: 11,
			value: $format('option_extreme', { default: 'Extreme' }),
		},
	];
</script>

<WeatherStationCard
	on:click
	icon="fas fa-sun"
	label={$format('title_uv_index_card', { default: 'UV index' })}
	value={uv?.rawValue}
	{status}
	description={$format('icon_name_illuminance', {
		default: 'Illuminance',
	})}
	descriptionValue={illuminance?.value}
>
	<div slot="main" class="d-flex">
		<svg width="112" height="30" viewBox="0 0 112 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M107.691 2H4.3068C1.1981 2 0 4.0147 0 6.5C0 8.9853 1.1981 11 4.3068 11H107.691C110.8 11 112 9.1493 112 6.6641C112 4.1788 110.8 2 107.691 2Z"
				fill="url(#uv_gradient)"
			/>

			<circle
				cx="2.5"
				cy="6.5"
				r="5"
				fill="#EDEDED"
				stroke="#808589"
				stroke-width="1.2"
				transform={`translate(${leftCircleX}, 0)`}
			/>

			<text x="1" y="26" fill="#9A9FA4" font-size="9">{MIN_UV}</text>
			<text x="111" y="26" fill="#9A9FA4" font-size="9" text-anchor="end">{MAX_UV}</text>

			<defs>
				<linearGradient
					id="uv_gradient"
					x1="0"
					y1="2"
					x2="112"
					y2="2"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#00FF00" />
					<stop offset="0.2" stop-color="#FFFF00" />
					<stop offset="0.4" stop-color="#FFA500" />
					<stop offset="0.6" stop-color="#FF0000" />
					<stop offset="0.8" stop-color="#FF00FF" />
					<stop offset="1" stop-color="#8000FF" />
				</linearGradient>
			</defs>
		</svg>
	</div>
</WeatherStationCard>

<style>
	svg {
		max-width: 100%;
		width: 140px;
		height: auto;
		margin-top: 25px;
	}
	svg circle {
		transition: transform 0.25s ease-in-out;
	}
</style>
